export const SITE = {
  name: "SVT Golden Fitness",
  phone: "+91 90361 95171",
  phoneRaw: "+919036195171",
  city: "Bengaluru, Karnataka",
  address: "SVT Golden Fitness, Bengaluru, Karnataka, India",
  email: "info@svtgoldenfitness.com",
  hours: "Mon - Sat: 5:00 AM - 10:00 PM  |  Sun: 6:00 AM - 12:00 PM",
  logo: "/logo.png",
  hero: "https://images.pexels.com/videos/3195395/free-video-3195395.jpg?auto=compress&cs=tinysrgb&w=1600",
};

export const PROGRAMS = [
  {
    name: "Strength",
    desc: "Build raw power with free weights and machines.",
    img: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "Cardio",
    desc: "Burn fat and boost stamina on top gear.",
    img: "https://images.unsplash.com/photo-1536922246289-88c42f957773?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    name: "CrossFit",
    desc: "High-energy functional training in a group.",
    img: "https://images.pexels.com/photos/9958670/pexels-photo-9958670.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Zumba",
    desc: "Dance your way to fitness with fun beats.",
    img: "https://images.pexels.com/photos/4090012/pexels-photo-4090012.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Personal Training",
    desc: "One-on-one coaching for faster results.",
    img: "https://images.pexels.com/photos/33846716/pexels-photo-33846716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Group Classes",
    desc: "Train together, stay motivated together.",
    img: "https://images.unsplash.com/photo-1518310383802-640c2de311b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1674834727206-4bc272bfd8da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.pexels.com/photos/29392546/pexels-photo-29392546.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1689877020200-403d8542d95d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.pexels.com/photos/841135/pexels-photo-841135.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.pexels.com/photos/4720777/pexels-photo-4720777.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const TESTIMONIALS = [
  {
    name: "Rahul Sharma",
    since: "Member for 8 months",
    quote: "Best gym in the area. The trainers actually care and the equipment is top-notch. I lost 12 kg here!",
  },
  {
    name: "Priya Nair",
    since: "Member for 1 year",
    quote: "I love the Zumba and group classes. Such a positive crowd and clean place. Highly recommend SVT Golden.",
  },
  {
    name: "Arjun Reddy",
    since: "Member for 6 months",
    quote: "Personal training changed my game. My coach pushes me every session. Worth every rupee.",
  },
];

export const FALLBACK_PLANS = [
  { id: "m1", name: "Monthly", duration_months: 1, price: 1500, pt_sessions: 0 },
  { id: "q1", name: "Quarterly", duration_months: 3, price: 4000, pt_sessions: 4 },
  { id: "y1", name: "Annual", duration_months: 12, price: 12000, pt_sessions: 12 },
];
